import React, { Component} from 'react'
import { connect } from 'react-redux'
import { isFetching } from 'utils/redux/fetching'
import { fetchCryptoMostWanted } from 'redux/actions/cryptoMostWanted'
import { fetchCryptoCurrencies } from 'redux/actions/cryptoCurrencies'
import { modes } from 'utils/redux/config/modes'
import FeaturedCryptoCurrencyCard from 'components/FeaturedCryptoCurrencyCard'
import Loader from 'components/Loader'
import Heading from 'components/Heading'
import Slider from 'components/carousel/Carousel'
import moment from 'moment'

class FeaturedCryptoCurrencyCardsContainer extends Component {
	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchCryptoCurrencies())
		dispatch(fetchCryptoMostWanted())
	}
	render () {
		if(this.props.isFetching) return <Loader />

		const { mostWanted, selectedMode } = this.props
		const modeSettings = modes[selectedMode]
		const actualDateTime = mostWanted[0].date
		return <div>
			<Heading
				text={`${modeSettings.namePl} за ${moment(actualDateTime).format('DD.MM.YYYY, HH:mm')}ч.`}
				classes={`u-heading-line u-heading-line-${modeSettings.oppositeColor}`} />
			<Slider
				className='c-featured-card__container c-featured-card__container--crypto'
				options={{
					slidesToShow: 4,
					autoplay: true,
					arrows: false,
					responsive: [
						{
							breakpoint: 980,
							settings: {
								slidesToShow: 3,
							}
						},
						{
							breakpoint: 820,
							settings: {
								slidesToShow: 2,
							}
						},
						{
							breakpoint: 550,
							settings: {
								slidesToShow: 1,
							}
						}
					]
				}}>
				{ mostWanted.map(currency => <FeaturedCryptoCurrencyCard key={currency.id} currency={currency} mode={selectedMode} />)}
			</Slider>
		</div>
	}
}

const mapStateToProps = state => {

	const { cryptoCurrencies, cryptoMostWanted } = state

	if (isFetching([cryptoCurrencies, cryptoMostWanted])) return { isFetching: true }

	return {
		mostWanted: cryptoMostWanted.data
	}
}


export default connect(mapStateToProps)(FeaturedCryptoCurrencyCardsContainer)
